import { QueryBuilderInterface } from "@share/common/types/interfaces/api/QueryBuilerInterface";
import { FilteringParams } from "@share/committees/committees-list/types/FilteringParams";
import { PagingStateInterface } from "@share/common/types/interfaces/list/PagingStateInterface";
import { dateInOriginalOffset } from "@common/dateTimeHelper";
import { DateTime } from "luxon";
import { getDates } from "@share/program/helpers/dates";

export class QueryBuilder implements QueryBuilderInterface {

    constructor(
        public readonly pagingState: PagingStateInterface,
        private readonly currentUserId: number,
        private readonly currentUserCompanyId: string | undefined
    ) {
    }

    getQuery(filterState: FilteringParams) {
        const take = 20;
        const offset = parseInt(filterState.timeZone);
        const date = !isNaN(offset) ? dateInOriginalOffset(DateTime.local(), offset, true).toISO() : DateTime.local().toISO();

        //если дата начала меньше local и дата конца больше local
        const where = {
            $and: [
                {
                    $or: [
                        {
                            $and: [
                                { beginAt: { [filterState.timeDirection]: date } },
                                ...(filterState.date ? this.getDateCondition(filterState.date, offset) : []),
                                ...(filterState.isOnlyMine ? [{ userIds: { $containsAny: [this.currentUserId] } }] : []),
                                ...(filterState.tagsIds?.length ? [{ tagsIds: { $containsAny: filterState.tagsIds } }] : []),
                                ...(filterState.subjectTypes ? [{ subjectType: { $in: filterState.subjectTypes } }] : []),
                                ...(filterState.keyword ? [this.getKeywordCondition(filterState.keyword)] : [])
                            ],
                        },
                        //TODO: remove after adding interface for now committees
                        {
                            ...(filterState.timeDirection === "$gte" ? {
                                $and: [
                                    { beginAt: { $lt: date } },
                                    { endAt: { $gt: date } }
                                ]
                            } : null),
                        }
                    ]
                },
                {
                    $or: [
                        {
                            ownerIds: { $containsAny: [this.currentUserId] }
                        },
                        {
                            userIds: { $containsAny: [this.currentUserId] }
                        },
                        (this.currentUserCompanyId ? { company: this.currentUserCompanyId } : null)
                    ]
                }
            ]

        };

        return {
            include: [
                'id', 'title', 'description', 'userIds', 'ticketIds',
                'beginAt', 'endAt', 'subjectType', 'location',
                'link', { 'company': ['id', 'title', { 'parentId': ['title', { 'parentId': ['title'] }] }] }, 'secretary', 'isClosed'
            ],
            skip: this.pagingState.skip,
            where,
            take,
            order: {
                beginAt: filterState.timeDirection === "$gte" ? "asc" : "desc"
            }
        }
    }

    setCount(count: number) {
        this.pagingState.count = count;
    }

    private getKeywordCondition(searchStr: string) {
        const parts: string[] = searchStr.split(' ');
        const words: string[] = parts.map((part: string) => `(?i).*${part}.*`);

        const searchableFields = ['title']

        return {
            $search: [
                searchableFields,
                words
            ]
        }
    }

    private getDateCondition(date: DateTime, offset: number) {
        let { dayStart, dayEnd } = getDates(date);

        dayStart = dateInOriginalOffset(dayStart, offset, true);
        dayEnd = dateInOriginalOffset(dayEnd, offset, true);

        return [
            { beginAt: { $gte: dayStart.toISO({ includeOffset: true }) } },
            { beginAt: { $lte: dayEnd.toISO({ includeOffset: true }) } }
        ]
    }
}
